<script>
export default {
    name: 'BaseCalendarNavigationPeriodYears',
};
</script>

<script setup>
import { computed, ref, watch } from 'vue';
import { getYears, getYearsRange } from '@/components/base-components/components/calendar/utils/periods.js';

const props = defineProps({
    value: {
        type:     Date,
        required: true,
    },
});

const emit = defineEmits({
    input: null,
});

const today = new Date();
const date = ref(new Date(props.value));

watch(() => props.value, () => {
    date.value = new Date(props.value);
});

const items = computed(() => getYears(date.value));

function goToPrevious() {
    const previous = new Date(date.value);

    previous.setFullYear(previous.getFullYear() - 12);

    date.value = previous;
}

function goToNext() {
    const next = new Date(date.value);

    next.setFullYear(next.getFullYear() + 12);

    date.value = next;
}
</script>

<template>
    <div>
        <slot
            name="navigation"
            :label="Object.values(getYearsRange(date)).join('-')"
            :go-to-previous="goToPrevious"
            :go-to-next="goToNext"
        />

        <div class="grid grid-cols-3">
            <base-button
                v-for="item in items"
                :key="item.toISOString()"
                :text="item.getFullYear() !== value.getFullYear()"
                :type="item.getFullYear() === value.getFullYear() ? 'secondary' : 'default'"
                @click="emit('input', item)"
            >
                <span class="relative flex items-center justify-center">
                    <span v-text="item.getFullYear()" />
                    <span
                        v-if="today.getFullYear() === item.getFullYear()"
                        class="absolute mt-5 border-t-2 border-current w-full"
                    />
                </span>
            </base-button>
        </div>
    </div>
</template>
